import {
  OPEN_MODAL,
  OPEN_MODAL_ANALYTIC_KEYS,
  CLOSE_MODAL,
} from '../modules/modals/modals.module';
import { dispatchPageLoad } from '../utils/analytics-helper';
import { isLanding } from '../../utils/transactions-util';

export const openModalAnalyticsDispatcher = () => (next) => (action) => {
  if (
    action.type === OPEN_MODAL &&
    action.payload &&
    !(
      action.payload.modalName === 'AUTOMATIC_TRANSACTION_DELETE' ||
      action.payload.modalName === 'AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS'
    )
  ) {
    const analyticsKey = OPEN_MODAL_ANALYTIC_KEYS[action.payload.modalName];
    if (analyticsKey) {
      dispatchPageLoad(analyticsKey);
    }
  }
  return next(action);
};

export const closeModalAnalyticsDispatcher = (store) => (next) => (action) => {
  if (action.type === CLOSE_MODAL && action.payload) {
    const { currentStep } = store.getState().progress;
    if (currentStep > 0) {
      const analyticsKey = `Step ${currentStep}`;
      dispatchPageLoad(analyticsKey);
    } else if (isLanding()) {
      dispatchPageLoad('Landing');
    }
  }
  return next(action);
};
